// extracted by mini-css-extract-plugin
export var fileUpload = "_jd-1";
export var modalButton = "_jd-0";